<template>
    <div class="wrapper">
                                    <div class="container">
                                        <div
                                            class="row mb_80 ApRow has-bg bg-boxed"
                                            style="background: no-repeat"
                                            data-bg_data=" no-repeat"
                                        >
                                            <div
                                                class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-sp-12 inline-md ApColumn"
                                            >
                                                <div
                                                    id="image-form_9908406600453400"
                                                    class="block liquid_box effect-img ApImage"
                                                >
                                                <!-- src="https://cdn.shopify.com/s/files/1/0905/2012/files/station-h1.jpg?v=1631239898" -->
                                                    <img
                                                        src="https://cdn.shopify.com/s/files/1/0905/2012/files/station-h1.jpg?v=1631239898"
                                                        class
                                                        alt
                                                        style="
                                                            width: 100%;
                                                            height: auto;
                                                        "
                                                        loading="lazy"
                                                    />
                                                    <div
                                                        class="image_description"
                                                    >
                                                        <div class="abs-inner">
                                                            <p>
                                                                sale up to 15%
                                                                off
                                                            </p>
                                                            <h4>
                                                                Home office
                                                                desks
                                                            </h4>
                                                            <a
                                                                href="blog/index.php?id_appagebuilder_profiles=23#"
                                                                data-mce-href="#"
                                                                >Shop Now<i
                                                                    class="fal fa-arrow-right"
                                                                ></i
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12 col-sp-12 inline-md ApColumn"
                                            >
                                                <div
                                                    id="image-form_14537017902943575"
                                                    class="block liquid_box effect-img ApImage"
                                                >
                                                    <img
                                                        src="https://cdn.shopify.com/s/files/1/0905/2012/files/station-h2.jpg?v=1631239898"
                                                        class
                                                        title
                                                        alt
                                                        style="
                                                            width: 100%;
                                                            height: auto;
                                                        "
                                                        loading="lazy"
                                                    />
                                                    <div
                                                        class="image_description"
                                                    >
                                                        <div class="abs-inner">
                                                            <p>
                                                                all page types
                                                            </p>
                                                            <h4>notebooks</h4>
                                                            <a
                                                                href="blog/index.php?id_appagebuilder_profiles=23#"
                                                                data-mce-href="#"
                                                                >Shop Now<i
                                                                    class="fal fa-arrow-right"
                                                                ></i
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-sp-12 one-line ApColumn"
                                            >
                                                <div
                                                    id="image-form_3894765117629303"
                                                    class="block liquid_box effect-img ApImage"
                                                >
                                                    <img
                                                        src="/images/banner/1.jpeg"
                                                        class
                                                        title
                                                        alt
                                                        style="
                                                            width: 100%;
                                                            height: auto;
                                                        "
                                                        loading="lazy"
                                                    />
                                                    <div
                                                        class="image_description"
                                                    >
                                                        <div class="abs-inner">
                                                            <p>office / home</p>
                                                            <h4>metal pens</h4>
                                                            <a
                                                                href="blog/index.php?id_appagebuilder_profiles=23#"
                                                                data-mce-href="#"
                                                                >Shop Now<i
                                                                    class="fal fa-arrow-right"
                                                                ></i
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    id="image-form_27572340243052695"
                                                    class="block liquid_box effect-img ApImage"
                                                >
                                                    <img
                                                        src="/images/banner/2.jpg"
                                                        class
                                                        title
                                                        alt
                                                        style="
                                                            width: 100%;
                                                            height: auto;
                                                        "
                                                        loading="lazy"
                                                    />
                                                    <div
                                                        class="image_description"
                                                    >
                                                        <div class="abs-inner">
                                                            <p>
                                                                Office Adhesive
                                                            </p>
                                                            <h4>Tape</h4>
                                                            <a
                                                                href="blog/index.php?id_appagebuilder_profiles=23#"
                                                                data-mce-href="#"
                                                                >Shop Now<i
                                                                    class="fal fa-arrow-right"
                                                                ></i
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
</template>